module.exports = __webpack_public_path__ + "static/media/re.c0d5bd91.svg";